import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module";


const GlobalLogisticsCatalogBasicInfoComponent = ({ selectedShippingProvider }: any) => {

    if (!selectedShippingProvider?.Providers) return null;

    const providers = selectedShippingProvider.Providers;

    return (
        <>
            {providers.map((provider: any, providerIndex: number) => {
                const descriptor = provider?.Descriptor || {};
                const lsp = provider?.LSPDescriptor || {};
                const rateCards = provider?.RateCards || [];
                const serviceTypes = provider?.ServiceTypes || [];

                return (
                    <div
                        key={providerIndex}
                        className="mb-6 border p-4 rounded shadow-sm bg-white"
                    >
                        {/* Provider Basic Info */}
                        <AccordionContainer
                            expandedPanel={`Provider-${providerIndex}`}
                            headerTitle={`Provider Details (${provider.ProviderName})`}
                            child={
                                <div className="p-4 bg-white text-sm space-y-3">

                                    <div>
                                        <h2 className="font-semibold text-blue-700 mb-2">Basic Information</h2>
                                        <ul className="list-disc list-inside">
                                            <li><strong>Provider ID:</strong> {provider.ProviderId}</li>
                                            <li><strong>Provider Name:</strong> {provider.ProviderName}</li>
                                            <li><strong>DBN Biz ID:</strong> {provider.DBNBizId}</li>
                                            <li><strong>CSP Published:</strong> {provider.IsPublishedInCSP ? "Yes" : "No"}</li>
                                        </ul>
                                    </div>

                                    <div>
                                        <h2 className="font-semibold text-blue-700 mb-2">LSP Descriptor</h2>
                                        <ul className="list-disc list-inside">
                                            <li><strong>Shipping Provider ID:</strong> {lsp.ShippingProviderId}</li>
                                            <li><strong>Name:</strong> {lsp.ShippingProviderName}</li>
                                            <li><strong>Internal Provider:</strong> {lsp.IsInternalProvider ? "Yes" : "No"}</li>
                                        </ul>
                                    </div>

                                </div>
                            }
                        />

                        {/* Transporter Details */}
                        <AccordionContainer
                            expandedPanel={`Transporter-${providerIndex}`}
                            headerTitle="Transporter Details"
                            child={
                                <div className="p-4 bg-white text-sm space-y-4">

                                    <div>
                                        <h2 className="font-semibold text-green-700 mb-2">Basic Info</h2>
                                        <ul className="list-disc list-inside">
                                            <li><strong>Email:</strong> {descriptor.TransporterEmailId}</li>
                                            <li><strong>Phone:</strong> {descriptor.TransporterPhoneNo}</li>
                                            <li><strong>Network Transporter:</strong> {descriptor.IsNetworkTransporter ? "Yes" : "No"}</li>
                                            <li><strong>Delivery Hub Enabled:</strong> {descriptor.IsDeliveryHubEnabled ? "Yes" : "No"}</li>
                                        </ul>
                                    </div>

                                    <div>
                                        <h2 className="font-semibold text-green-700 mb-2">Address</h2>
                                        <ul className="list-disc list-inside">
                                            {descriptor?.Address && Object.entries(descriptor.Address).map(([key, value]) => (
                                                <li key={key}><strong>{key}:</strong> {String(value)}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div>
                                        <h2 className="font-semibold text-green-700 mb-2">Service Types</h2>
                                        {serviceTypes.map((s: any, idx: number) => (
                                            <div key={idx} className="border rounded p-3 bg-gray-50 mb-3">
                                                <strong>{s.Name}</strong> ({s.Code})
                                                <ul className="list-disc list-inside mt-2">
                                                    {s.RoutingModels?.map((rm: any, rIdx: number) => (
                                                        <li key={rIdx}>
                                                            Routing: {rm.Name} ({rm.Code})
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>

                                </div>
                            }
                        />

                        {/* Rate Cards */}
                        <AccordionContainer
                            expandedPanel={`RateCards-${providerIndex}`}
                            headerTitle="Rate Cards"
                            child={
                                <div className="p-4 bg-white text-sm space-y-6">

                                    {rateCards.length > 0 ? rateCards.map((rate: any, idx: number) => {
                                        const logistics = rate.LogisticsShippingInfo || {};

                                        return (
                                            <div key={idx} className="border p-4 rounded shadow bg-gray-50">

                                                <h3 className="font-semibold mb-2 text-purple-700">
                                                    {rate.Name}
                                                </h3>

                                                {/* General Info */}
                                                <div className="mb-3">
                                                    <strong>Order Type:</strong> {rate.LogisticsOrderType}
                                                </div>

                                                {/* Serviceable Pincodes */}
                                                <div className="mb-3">
                                                    <strong>Serviceable Pin Codes:</strong><br />
                                                    <span className="text-xs">
                                                        {rate.ServiceablePinCodes?.PinCodes?.join(", ")}
                                                    </span>
                                                </div>

                                                {/* Slot Info */}
                                                <div className="mb-3">
                                                    <strong>Duration:</strong> {rate.DurationSlot?.Duration} <br />
                                                    <strong>Pickup Slots:</strong> {rate.DurationSlot?.PickupTimeSlots?.join(", ")} <br />
                                                    <strong>Delivery Slots:</strong> {rate.DurationSlot?.DeliveryTimeSlots?.join(", ")}
                                                </div>

                                                {/* Price Details */}
                                                <div className="border-t pt-3 mt-3">
                                                    <h4 className="font-semibold text-purple-700 mb-2">Price Details</h4>
                                                    {Object.entries(logistics?.PriceDetails || {}).map(([key, obj]: any) => (
                                                        <div key={key}>
                                                            <strong>{key}:</strong> {obj.currency} {obj.value}
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Distance */}
                                                <div className="border-t pt-3 mt-3">
                                                    <h4 className="font-semibold text-purple-700 mb-2">Distance Details</h4>
                                                    {Object.entries(logistics?.DistanceDetails || {}).map(([key, val]: any) => (
                                                        <div key={key}>
                                                            <strong>{key}:</strong> {val}
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Weight */}
                                                <div className="border-t pt-3 mt-3">
                                                    <h4 className="font-semibold text-purple-700 mb-2">Weight Details</h4>
                                                    {Object.entries(logistics?.WeightDetails || {}).map(([key, val]: any) => (
                                                        <div key={key}>
                                                            <strong>{key}:</strong> {val}
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Size */}
                                                <div className="border-t pt-3 mt-3">
                                                    <h4 className="font-semibold text-purple-700 mb-2">Size Details</h4>
                                                    {Object.entries(logistics?.SizeDetails || {}).map(([key, val]: any) => (
                                                        <div key={key}>
                                                            <strong>{key}:</strong> {val}
                                                        </div>
                                                    ))}
                                                </div>

                                            </div>
                                        );
                                    }) : (
                                        <p>No rate cards found.</p>
                                    )}

                                </div>
                            }
                        />
                    </div>
                );
            })}
        </>
    );
};

export default GlobalLogisticsCatalogBasicInfoComponent;
